var _circle, _path, _ellipse, _path2, _path3, _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgInfoIcon(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 921.1 921.09"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 460.48,
    cy: 460.55,
    r: 451.94,
    fill: "#dcdede"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.1 471.28c105.26-88.27 119-245.17 30.76-350.43q-2.13-2.55-4.33-5a256.69 256.69 0 00-101.7-70.28 54.55 54.55 0 01-21.4 25.22c-17.15 11.57-34.09 23.46-50.63 36a468.63 468.63 0 00-76.21 73.76c-17.27 23.37-40.59 50-52.29 76.52-14.66 36.05-31.93 73-37.76 111.46-9.75 34.62-19.47 70.59-15.66 103.17 7.13 47.62 19.47 118.6 37.76 163A701.34 701.34 0 0078.1 701c21.18 28.56 39.45 41.66 53.43 62.63s33.75 24.78 48.82 45.14c7.79 10.49 31 13.72 38.38 24.44a246.93 246.93 0 0113 21l.42.12a103.37 103.37 0 0155.21 33.75c124.27-59.63 176.66-208.71 117-333a249.62 249.62 0 00-65.3-83.81z",
    fill: `url(#${_id})`
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.17 120.67c-1.76 0-3.53 0-5.28.11a37.57 37.57 0 01-11.26 10 358.2 358.2 0 00-49.33 51.59 397.62 397.62 0 00-31.15 47.9c-4.93 9.09-9.48 18.26-14.46 27.26-4.26 7.71-8.3 15.58-12 23.52a264.68 264.68 0 00-11.57 44.31c-.92 5-2 10.13-3.24 15.09a153.38 153.38 0 10138.26-219.81z",
    fill: "#fbfbfb"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.88,
    cy: 310.64,
    rx: 50.94,
    ry: 49.98,
    fill: "#1d1d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M460.51 921.09C206.16 921.09 0 714.86 0 460.51S206.24-.06 460.59 0 921.1 206.22 921.1 460.57 714.88 921.11 460.52 921.09zm0-903.86c-244.83 0-443.32 198.45-443.33 443.28s198.45 443.32 443.28 443.33 443.32-198.45 443.33-443.28c-.01-244.85-198.47-443.31-443.28-443.33z",
    fill: "#1253fa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M549.73 236.37c0-39.44 33-72.44 72.44-72.44s72.43 33 72.43 72.44-33 72.43-72.43 72.43-72.44-33-72.44-72.43zm12.07 107.85h120.73v402.42H561.8z",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 64.83,
    y1: 126.45,
    x2: 64.83,
    y2: 134.35,
    gradientTransform: "matrix(32.35 0 0 64.9 -1878.16 -7922.8)",
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#03a7fd"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600dc"
  })))));
}
export default SvgInfoIcon;